import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=6a930153&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=6a930153&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a930153",
  null
  
)

export default component.exports